/**
 * The global state selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = state => state?.global || initialState;

const selectRouter = state => state.router;

const makeSelectCurrentUser = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.currentUser,
  );

const makeSelectUserPermisson = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.userPermission,
  );

const makeSelectLoading = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.error,
  );

const makeSelectRepos = () =>
  createSelector(
    selectGlobal,
    globalState => globalState.userData.repositories,
  );

const makeSelectLocation = () =>
  createSelector(
    selectRouter,
    routerState => routerState.location,
  );

const makeSelectHanyoKubunArr = () =>
  createSelector(
    selectRouter,
    routerState => routerState.hanyoKubunArr,
  );
const makeSelectInjuryClassificationArr = () =>
  createSelector(
    selectRouter,
    routerState => routerState.injuryClassificationArr,
  );

export {
  selectGlobal,
  makeSelectUserPermisson,
  makeSelectCurrentUser,
  makeSelectLoading,
  makeSelectError,
  makeSelectRepos,
  makeSelectLocation,
  makeSelectHanyoKubunArr,
  makeSelectInjuryClassificationArr
};
